"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvirioLocationMarkerClusterer = void 0;
var React = require("react");
var react_google_maps_1 = require("@120wateraudit/react-google-maps");
var EnvirioMarker_1 = require("./EnvirioMarker");
var EnvirioMapStyles_1 = require("./EnvirioMapStyles");
var EnvirioLocationMarkerClusterer = /** @class */ (function (_super) {
    __extends(EnvirioLocationMarkerClusterer, _super);
    function EnvirioLocationMarkerClusterer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EnvirioLocationMarkerClusterer.prototype.render = function () {
        var _a = this.props, markers = _a.markers, keyExtension = _a.keyExtension, bounds = _a.bounds;
        return (React.createElement(react_google_maps_1.MarkerClusterer, { averageCenter: true, enableRetinaIcons: true, gridSize: 60, styles: EnvirioMapStyles_1.clusterIconStyles, defaultTitle: 'Click to see more locations.', title: "Click to see all locations" }, markers.map(function (marker, i) {
            var key = marker.position.lat + "-" + marker.position.lng + i + (keyExtension || '');
            bounds.extend(marker.position);
            var icon = EnvirioMarker_1.getPinColorForMap(marker.color);
            if (!marker.info) {
                marker.info = {};
            }
            return (React.createElement(react_google_maps_1.OverlayView, { key: key, position: marker.position, mapPaneName: react_google_maps_1.OverlayView.OVERLAY_MOUSE_TARGET },
                React.createElement(react_google_maps_1.Marker, { onClick: function () {
                        if (typeof marker.onClick !== 'function') {
                            return;
                        }
                        marker.onClick();
                    }, key: key, position: marker.position, clickable: true, title: marker.location
                        ? marker.location.addressLine1 + "\n" + marker.location.city + ", " + marker.location.state + " " + marker.location.zip
                        : 'No address found', icon: icon })));
        })));
    };
    return EnvirioLocationMarkerClusterer;
}(React.Component));
exports.EnvirioLocationMarkerClusterer = EnvirioLocationMarkerClusterer;
//# sourceMappingURL=EnvirioLocationMarkerClusterer.js.map